import { isAuthenticated, getUSER } from "../../services/auth";
import { producaov2 } from "../../services/apis";
import { getUserNode } from "../../services/auth_node";

const habilita_mentoria = (
  id,
  proxima = false,
  aovivo = false,
  workshop = false
) => {
  if (
    isAuthenticated() &&
    (getUSER().is_premium == 0 || getUSER().is_premium === undefined)
  ) {
    if (aovivo) {
      producaov2
        .post("lives/enable", {
          id_pessoa: getUSER().id,
          id_curso: btoa(id),
        })
        .then((res) => {
          window.location.href = "/online/assistir/" + btoa(id);
        })
        .catch((err) => {
          console.error(err);
          window.location.href = "/online/assistir/" + btoa(id);
        });
    } else {
      window.location = "https://www.voitto.com.br/premium";
    }
  } else if (isAuthenticated() && getUSER().is_premium != 0) {
    producaov2
      .post("lives/enable", {
        id_pessoa: getUserNode().id,
        id_curso: btoa(id),
      })
      .then((res) => {
        window.location.href = "/online/assistir/" + btoa(id);
      })
      .catch((err) => {
        console.error(err);
        window.location.href = "/online/assistir/" + btoa(id);
      });
  } else {
    if (aovivo) {
      localStorage.setItem("redirect", `/lives`);
      window.location.href = "/login";
    } else if (workshop) {
      localStorage.setItem("redirect", `/workshops`);
      window.location.href = "/login";
    } else {
      window.open("https://www.voitto.com.br/premium");
    }
  }
};

export default habilita_mentoria;
